import React from 'react';

import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const RadioInput = ({
    dataOptiontype,
    id,
    onChange,
    name,
    label,
    value,
    checked,
}) => (
    <Form.Check
        type="radio"
        data-optiontype={dataOptiontype}
        id={id}
        label={label}
        value={value}
        checked={checked}
        name={name}
        onChange={onChange}
    />
);

RadioInput.propTypes = {
    dataOptiontype: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
};

export default RadioInput;
